import { Menu, MenuItem, ListItem, Typography } from "@mui/material";
import ManualAvatar from "../Avatar/Avatar";

export default function ProfileMenu({ anchorEl, open, handleMenuClose, Data }) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          mt: 1.5,
          minWidth: 180,
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        },
      }}
      sx={{ zIndex: 1300 }}
    >
      <ListItem
        sx={{
          padding: "10px",
          gap: "5px",
        }}
      >
        <ManualAvatar
          src=""
          alt="Profile Picture"
          height="30px"
          width="30px"
          name={Data?.name}
        />
        <Typography fontSize={"16px"}>{Data?.name}</Typography>
      </ListItem>

      <MenuItem
        onClick={() => {
          handleMenuClose();
          localStorage.removeItem("Token");
          window.location.href = "/signin";
        }}
      >
        Log Out
      </MenuItem>
    </Menu>
  );
}
